<template>
	<div class="trip-price-diagram">
		<!-- Arrows -->
		<span class="arrow-left" @click="move('left', $event)">
			<i class="wa-icon-long-arrow-left"></i>
		</span>
		<span class="arrow-right" @click="move('right', $event)">
			<i class="wa-icon-long-arrow-right"></i>
		</span>

		<!-- List -->
		<ul>
			<li v-for="(date, index) in dates"
			:class="{ item: true, 'not-available': date.price <= 0, 'cheapest': date.price === minPrice, 'last-day': isLastDay(date.date), 'first-day': isFirstDay(date.date) }"
			@mouseover="showPriceTooltip = index"
			@mouseout="showPriceTooltip = null"
			>
				<span class="month-label" v-if="isFirstDay(date.date)">
					<strong>{{ 'general.monthByNumber.' + date.date.getMonth() | trans }}</strong> {{ date.date.getFullYear() }}
				</span>
				
				<div class="wrapper" v-bind:style="{ height: (date.price > 0 ? itemHeight/maxPrice*date.price + 'px' : false) }">
					<div class="bar">
						<span class="info">
							{{ 'general.shortWeekdayByNumber.' + date.date.getDay() | trans }}
							<small>{{ date.date.getDate() }}</small>
						</span>
					</div>
					
					<span class="price" :class="{ visible: showPriceTooltip === index || date.price === minPrice }">
						{{ date.price | formatPrice }} &euro;

						<svg v-if="date.price === minPrice" class="arrow-down" width="11px" height="4px" viewBox="0 0 11 4" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<g fill="#FF5D5D" stroke="none" stroke-width="1" fill-rule="evenodd">
								<path d="M20.3620488,27 C23.3163707,27 23.8301659,23 25.5,23 C26.2568073,23 26.7761514,23.8216446 27.3928618,24.7201572 C28.1368731,25.8041399 29.0225961,27 30.6379512,27 C33.5922731,27 17.4077269,27 20.3620488,27 Z" transform="translate(-20.000000, 27.000000) scale(1, -1)"></path>
							</g>
						</svg>

						<svg v-if="date.price !== minPrice" class="arrow-down" width="11px" height="4px" viewBox="0 0 11 4" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<g fill="#FFFFFF" stroke="none" stroke-width="1" fill-rule="evenodd">
								<path d="M20.3620488,27 C23.3163707,27 23.8301659,23 25.5,23 C26.2568073,23 26.7761514,23.8216446 27.3928618,24.7201572 C28.1368731,25.8041399 29.0225961,27 30.6379512,27 C33.5922731,27 17.4077269,27 20.3620488,27 Z" transform="translate(-20.000000, 27.000000) scale(1, -1)"></path>
							</g>
						</svg>
					</span>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	props: ['loadEndpoint'],
	data: function() {
		return {
			dates: [],
			isLoading: false,
			offset: 0,
			itemHeight: 125,
			showPriceTooltip: null
		}
	},
	mounted: function() {
		this.load();
	},
	computed: {
		maxPrice: function() {
			var max = 0.0;

			for (var i = 0; i < this.dates.length; i++) {
				if (this.dates[i].price > 0 && (max === 0.0 || this.dates[i].price > max)) {
					max = this.dates[i].price;
				}
			}

			return max;
		},
		minPrice: function() {
			var min = 0.0;

			for (var i = 0; i < this.dates.length; i++) {
				if (this.dates[i].price > 0 && (min === 0.0 || this.dates[i].price < min)) {
					min = this.dates[i].price;
				}
			}

			return min;
		},
		sortedDates: function() {
			return Math.random();
			/*arr.sort(function(a, b){
				var keyA = new Date(a.updated_at),
				keyB = new Date(b.updated_at);

				if(keyA < keyB) return -1;
				if(keyA > keyB) return 1;
				return 0;
			});*/
		}
	},
	methods: {
		load: function() {
			var params = this.$root.$refs.filterbar.buildParams()
			var self = this;

			//Activate loading state
			this.isLoading = true;

			params.pageOffset = this.offset;
			params.pageLimit = 60;

			//Make request
			axios.get(this.loadEndpoint, {
				params: params
			}).then(function (response) {
				//Push result to current dates set.
				Array.prototype.push.apply(self.dates, response.data.results.map(function(item) {
					//Convert string dates to date objects.
					var parts = item.date.split('-');
					item.date = new Date(parts[0], parts[1] - 1, parts[2]);

					return item;
				}));

				//Deactive loading state
				self.isLoading = false;

				//Force update
				self.$forceUpdate();
			}).catch(function (error) {
				console.error(error);
				alert('Error. Please check the console.');
			});
		},
		move: function(direction, event) {
			var arrow = $(event.target);
			var list = $(event.target).parent().children('ul').eq(0);
			var _scrollLeft = list.scrollLeft();

			if ((_scrollLeft === 0 && direction === 'left') || (_scrollLeft === list[0].scrollWidth - list.width() && direction === 'right')) {
				arrow.animateCss('shake');
				return false;
			}
			var scrollWidth = list.width() / 3;
			var summand = direction === 'left' ? -scrollWidth : scrollWidth;

			var self = this;
			list.stop().animate({
				'scrollLeft' : (_scrollLeft + summand) + 'px'
			}, function() {
				if (direction === 'right') {
					self.checkLoad()
				}
			});
		},
		checkLoad: function() {
			var list = $(this.$el).find('ul');
			var remainingSpace = list[0].scrollWidth - list.width() - list.scrollLeft();
			
			if (remainingSpace <= list.width() / 2) {
				this.offset += 60;
				this.load();
			}
		},
		isLastDay: function(dt) {
			var test = new Date(dt.getTime()),
			month = test.getMonth();

			test.setDate(test.getDate() + 1);
			return test.getMonth() !== month;
		},
		//Checks if the given date is the first day of month in the current "dates" variable.
		isFirstDay: function(dt) {
			if (dt.getDate() === 1) return true;
			if (this.dates[0].date == dt) return true;

			return false;
		}
	}
}
</script>